var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.543,
    height: 11.543,
    viewBox: "0 0 11.543 11.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout_2_",
    "data-name": "logout (2)",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11124",
    "data-name": "Path 11124",
    d: "M7.214,6.256a.481.481,0,0,0-.481.481V8.661a.481.481,0,0,1-.481.481H4.809V1.928a.969.969,0,0,0-.655-.914L4.012.966h2.24a.481.481,0,0,1,.481.481V2.89a.481.481,0,0,0,.962,0V1.447A1.445,1.445,0,0,0,6.252,0H1.082a.378.378,0,0,0-.051.011C1.008.012.985,0,.962,0A.963.963,0,0,0,0,.966V9.623a.969.969,0,0,0,.655.914l2.894.965a1,1,0,0,0,.3.045.963.963,0,0,0,.962-.962V10.1H6.252A1.445,1.445,0,0,0,7.7,8.661V6.737a.481.481,0,0,0-.481-.481Zm0,0",
    transform: "translate(0 0)",
    fill: "#0075e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11125",
    "data-name": "Path 11125",
    d: "M282.482,108.73l-1.924-1.924a.481.481,0,0,0-.821.34v1.443h-1.924a.481.481,0,1,0,0,.962h1.924v1.443a.481.481,0,0,0,.821.34l1.924-1.924a.48.48,0,0,0,0-.68Zm0,0",
    transform: "translate(-271.08 -104.257)",
    fill: "#0075e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ab7a18ffcba1589926b30ed0ac56451d.svg";
export { ForwardRef as ReactComponent };